/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateLeadCareAttributes200ResponseDataInner } from './UpdateLeadCareAttributes200ResponseDataInner';
import {
    UpdateLeadCareAttributes200ResponseDataInnerFromJSON,
    UpdateLeadCareAttributes200ResponseDataInnerFromJSONTyped,
    UpdateLeadCareAttributes200ResponseDataInnerToJSON,
    UpdateLeadCareAttributes200ResponseDataInnerToJSONTyped,
} from './UpdateLeadCareAttributes200ResponseDataInner';

/**
 * 
 * @export
 * @interface UpdateLeadCareAttributes200Response
 */
export interface UpdateLeadCareAttributes200Response {
    /**
     * 
     */
    data?: Array<UpdateLeadCareAttributes200ResponseDataInner>;
}

/**
 * Check if a given object implements the UpdateLeadCareAttributes200Response interface.
 */
export function instanceOfUpdateLeadCareAttributes200Response(value: object): value is UpdateLeadCareAttributes200Response {
    return true;
}

export function UpdateLeadCareAttributes200ResponseFromJSON(json: any): UpdateLeadCareAttributes200Response {
    return UpdateLeadCareAttributes200ResponseFromJSONTyped(json, false);
}

export function UpdateLeadCareAttributes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadCareAttributes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UpdateLeadCareAttributes200ResponseDataInnerFromJSON)),
    };
}

export function UpdateLeadCareAttributes200ResponseToJSON(json: any): UpdateLeadCareAttributes200Response {
    return UpdateLeadCareAttributes200ResponseToJSONTyped(json, false);
}

export function UpdateLeadCareAttributes200ResponseToJSONTyped(value?: UpdateLeadCareAttributes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UpdateLeadCareAttributes200ResponseDataInnerToJSON)),
    };
}

